module.exports = __webpack_public_path__ + "img/sxsjs11.ba9bd6f8.png";